import React from 'react'
import InfiniteCarousel from 'react-leaf-carousel'
import cus1 from '../../assets/cus1.png'
import cus2 from '../../assets/cus2.png'
function Custmers() {
    return (
        <div className="partner__container">
            <h1 className={"heading_section"}>عملائنا</h1>
            <InfiniteCarousel
                
                dots={true}
                slidesToScroll={4}
                slidesToShow={4}
                scrollOnDevice={true}
                arrows={false}
                autoCycle={true}
                animationDuration={100}
            >
                <div >
                    <img src={cus1} alt="" />
                </div>

                <div >
                    <img src={cus2} alt="" />
                </div>

                <div >
                    <img src={cus1} alt="" />
                </div>

                <div >
                    <img src={cus2} alt="" />
                </div>

                <div >
                    <img src={cus1} alt="" />
                </div>
                <div>
                    <img src={cus2} alt="" />
                </div>

            </InfiniteCarousel>
        </div>
    )
}

export default Custmers
